import logo from './logo/logo.png';
import loginLogo from './logo/loginLogo.png';
import faviconLogo from './logo/faviconLogo.png';
import facebookLogo from './logo/facebookLogo.png';
import googleLogo from './logo/googleLogo.png';
import decorImg from './logo/decorLogin.jpg';
import chairImg from './logo/chair.png';
import signInSignUpBG from './images/signInSignUpBG1.jpg'; // Switched to optimized 270KB JPG
import logoImage from './logo/logoImage.png';
import background from './images/background.png';

// Footer
import freeShipping from './images/footer/FreeShipping.png';
import highQuality from './images/footer/HighQuality.png';
import support from './images/footer/Support.png';
import warrantyProtection from './images/footer/WarrantyProtection.png';

export const assets: any = {
    logo,
    loginLogo,
    faviconLogo,
    facebookLogo,
    googleLogo,
    decorImg,
    chairImg,
    signInSignUpBG,
    logoImage,
    background,

    // Footer
    freeShipping,
    highQuality,
    support,
    warrantyProtection,
};
